module.exports = __webpack_public_path__ + "static/cf-reg-32fe2b378031049a164d948d24cbc676.eot";